export type AdGroupColumnKey =
  | 'status'
  | 'time_created'
  | 'budget'
  | 'scheduling'
  | 'optimization_goal'
  | 'billing_event'
  | 'bid_type'
  | 'bid_price'
  | 'pacing'
  | 'placements'
  | 'gender'
  | 'age_groups'
  | 'location_ids'
  | 'languages'
  | 'modify_time'
  | 'promotion_type'
  | 'feed_type';

export type AdGroupColumnTab = 'delivery' | 'bidding' | 'targeting' | 'advanced';

export interface AdGroupColumnDef {
  key: AdGroupColumnKey;
  label: string;
  tab: AdGroupColumnTab;
}

export const AD_GROUP_COLUMN_DEFS: AdGroupColumnDef[] = [
  { key: 'status', label: 'Status', tab: 'delivery' },
  { key: 'time_created', label: 'Time Created', tab: 'delivery' },
  { key: 'budget', label: 'Budget', tab: 'delivery' },
  { key: 'scheduling', label: 'Scheduling', tab: 'delivery' },
  { key: 'optimization_goal', label: 'Optimization Goal', tab: 'bidding' },
  { key: 'billing_event', label: 'Billing Event', tab: 'bidding' },
  { key: 'bid_type', label: 'Bid Type', tab: 'bidding' },
  { key: 'bid_price', label: 'Bid Price', tab: 'bidding' },
  { key: 'pacing', label: 'Pacing', tab: 'bidding' },
  { key: 'placements', label: 'Placements', tab: 'targeting' },
  { key: 'gender', label: 'Gender', tab: 'targeting' },
  { key: 'age_groups', label: 'Age Groups', tab: 'targeting' },
  { key: 'location_ids', label: 'Location IDs', tab: 'targeting' },
  { key: 'languages', label: 'Languages', tab: 'targeting' },
  { key: 'promotion_type', label: 'Promotion Type', tab: 'advanced' },
  { key: 'feed_type', label: 'Feed Type', tab: 'advanced' },
  { key: 'modify_time', label: 'Last Modified', tab: 'advanced' },
];

export const DEFAULT_AD_GROUP_COLUMNS = new Set<AdGroupColumnKey>([
  'status',
  'time_created',
  'budget',
  'scheduling',
]);
